import { Enterprise } from '@/domain/models/Enterprise';
import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

interface Interface {
  fetch: () => Promise<Enterprise>;
}

export class EnterpriseService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async fetch(): Promise<Enterprise> {
    return await this.restClient.get<Enterprise>(
      `${DASHBOARD_API_ORIGIN}/api/enterprise` as const
    );
  }
}
